import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={54} height={81} viewBox="0 0 54 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M48.449.75v17.036h-26.45l-.997 9.67c1.618-.237 3.26-.389 4.98-.389 6.985 0 13.55 2.187 18.382 6.38 4.844 4.202 7.898 10.384 7.898 18.256 0 16.633-12.78 28.547-30.623 28.547-9.398 0-16.234-3.236-20.595-6.717l-.288-.23.006-.368.319-18.814.048-2.89 1.363 2.55c1.18 2.206 3.615 4.44 6.763 6.126 3.137 1.68 6.91 2.778 10.69 2.778 7.648 0 12.596-4.53 12.596-10.454 0-3.192-1.365-5.744-3.773-7.521-2.43-1.794-5.966-2.826-10.307-2.826-5.368 0-10.944 1.652-15.16 4.422l-1.288.846.13-1.536L5.848 1.438 5.908.75h42.54z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
